var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._l((_vm.links),function(link){return _c('a',{key:link.name,attrs:{"href":link.href,"target":"_blank"}},[_vm._v(_vm._s(link.name))])}),_c('a',{on:{"click":_vm.handleOpenCookies}},[_vm._v(_vm._s(_vm.$t('cookies_polices')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }